/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for finalizing no-show meetings.

margin_hours: grace window after scheduled end to consider as no-show.
statuses: booking statuses to consider (e.g., confirmed, pending).
 */
export interface MeetingsNoShowFinalizeParams {
  marginHours?: number;
  statuses?: string[];
}
